export const extractStudentIdsFromErrorMessage = (message: string) =>
  message.split('students: ')[1]?.split(', ') || [];
